import { render } from "./MainAbout.vue?vue&type=template&id=5a00571e&scoped=true&ts=true"
import script from "./MainAbout.vue?vue&type=script&lang=ts"
export * from "./MainAbout.vue?vue&type=script&lang=ts"

import "./MainAbout.vue?vue&type=style&index=0&id=5a00571e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a00571e"]])

export default __exports__